{
  "moreActions": "Daha fazla eylem"
}
